import { render, staticRenderFns } from "./imageViewpoint.vue?vue&type=template&id=dbf8d4f6&scoped=true&"
import script from "./imageViewpoint.vue?vue&type=script&lang=js&"
export * from "./imageViewpoint.vue?vue&type=script&lang=js&"
import style0 from "./imageViewpoint.vue?vue&type=style&index=0&id=dbf8d4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf8d4f6",
  null
  
)

export default component.exports